import { useEffect } from 'react';

import { isApplicationModeInfinity } from 'src/data/system';
import { captureMessage } from 'src/lib/sentry';
// @ts-expect-error - useErrorHandler does not have types
import { useErrorHandler } from 'src/services/useErrorHandler';
// @ts-expect-error - useCurrentCustomerId is not typed yet
import { useCurrentCustomerId } from 'src/store/customer';
import { useTemplatesActions } from 'src/store/templates';
// @ts-expect-error - useCurrentWorkspaceId is not typed yet
import { useCurrentWorkspaceId } from 'src/store/workspace';

export const useLoadRecentlyUsedTemplates = () => {
  const currentCustomerId = useCurrentCustomerId();
  const currentWorkspaceId = useCurrentWorkspaceId();

  const handleError = useErrorHandler();
  const templatesActions = useTemplatesActions();

  useEffect(() => {
    if (!currentCustomerId || !currentWorkspaceId) {
      return;
    }

    // we don't need "recently used templates" in Infinity
    if (isApplicationModeInfinity()) {
      return;
    }

    const fetchData = async () => {
      try {
        await templatesActions.queryRecentlyUsedTemplates(currentCustomerId, currentWorkspaceId);
      } catch (error) {
        captureMessage('Error while fetching "recently used templates"', {
          level: 'warning',
          extra: {
            error: (error as Error).toString(),
            source: 'useLoadRecentlyUsedTemplates',
          },
        });
      }
    };

    fetchData();
  }, [currentCustomerId, currentWorkspaceId, handleError, templatesActions]);
};
